import { OnboardingRootState } from "../reducers/rootReducer";
import { getOnboardingState } from "./rootSelectors";

export const getIsPitchEnabled = (state: OnboardingRootState): boolean =>
  getOnboardingState(state).capabilities?.isPitchEnabled ?? false;

export const getIsAaaUser = (state: OnboardingRootState): boolean =>
  getOnboardingState(state).capabilities?.isAaaUser ?? false;
